import { api } from './api';
import { CreateEventRequest, EventResponse, GuestInfo, PhotoResponse } from '../types';

export const eventService = {
  async listEvents(): Promise<EventResponse[]> {
    const res = await api.get('/admin/events');
    return res.data;
  },

  async createEvent(req: CreateEventRequest): Promise<EventResponse> {
    const res = await api.post('/admin/events', req);
    return res.data;
  },

  async updateEvent(eventId: number, name: string, description: string): Promise<EventResponse> {
    const res = await api.put(`/admin/events/${eventId}`, { name, description });
    return res.data;
  },

  async deleteEvent(eventId: number): Promise<void> {
    await api.delete(`/admin/events/${eventId}`);
  },

  async getEvent(eventId: number): Promise<EventResponse> {
    const res = await api.get(`/admin/events/${eventId}`);
    return res.data;
  },

  async toggleUpload(eventId: number): Promise<EventResponse> {
    const res = await api.put(`/admin/events/${eventId}/toggle-upload`);
    return res.data;
  },

  async getGuests(eventId: number): Promise<GuestInfo[]> {
    const res = await api.get(`/admin/events/${eventId}/guests`);
    return res.data;
  },

  async getEventPhotos(eventId: number): Promise<PhotoResponse[]> {
    const res = await api.get(`/admin/events/${eventId}/photos`);
    return res.data;
  },

  async approvePhoto(photoId: number): Promise<void> {
    await api.put(`/admin/photos/${photoId}/approve`);
  },

  async rejectPhoto(photoId: number): Promise<void> {
    await api.put(`/admin/photos/${photoId}/reject`);
  },

  async deletePhoto(photoId: number): Promise<void> {
    await api.delete(`/admin/photos/${photoId}`);
  },

  getQRUrl(eventId: number, sessionToken: string): string {
    return `${api.defaults.baseURL}/admin/events/${eventId}/qr`;
  },

  getDownloadUrl(eventId: number): string {
    return `${api.defaults.baseURL}/admin/events/${eventId}/download`;
  },
};
